export const CARDS_BLOCK_b13 = {
  "blockType": "CARDS",
  "blockDesign": "BYOCards",
  "editFormName": "DESIGN_CARD_PANEL",
  "styleProps": {
    "background-color": "#ffffff",
    "padding": "120px 20px 120px 20px",
    "background-image": "url('')",
    "background-repeat": "",
    "background-position": "center",
    "background-size": "cover"
  },
  "headings": [
    {
      "text": "Our Leadership Team",
      "styleProps": {
        "text-align": "center",
        "color": "#333333",
        "font-size": "3.75rem",
        "line-height": "1",
        "font-weight": "600"
      },
      "stylePropsTab": {
        "font-size": "3rem",
        "line-height": "1"
      },
      "stylePropsMob": {
        "font-size": "1.875rem",
        "line-height": "2.25rem"
      }
    },
    {
      "text": "Meet the visionaries behind our company:",
      "styleProps": {
        "color": "#333333",
        "font-size": "1.5rem",
        "line-height": "2rem",
        "margin": "30px 0px 50px 0px",
        "text-align": "center"
      },
      "stylePropsTab": {
        "font-size": "1.25rem",
        "line-height": "1.75rem",
        "margin": "30px 0px 40px 0px"
      },
      "stylePropsMob": {
        "font-size": "1.125rem",
        "line-height": "1.75rem"
      }
    }
  ],
  "cardElements": [
    {
      "type": "text",
      "id": 1746529638292,
      "elIndex": 0,
      "text": "[[name]]",
      "location": "B",
      "params": [
        {
          "value": "name",
          "label": "name"
        }
      ],
      "styleProps": {
        "color": "#333333",
        "font-size": "1.875rem",
        "line-height": "2.25rem",
        "font-weight": "900",
        "font-family-bk": "'Lato', sans-serif",
        "font-family": "'Lato', sans-serif",
        "font-family-cust": "",
        "padding": "0px 0px 2px 0px"
      },
      "stylePropsTab": {
        "font-size": "1.5rem",
        "line-height": "2rem",
        "padding": "0px 0px 0px 0px"
      },
      "stylePropsMob": {
        "font-size": "1.25rem",
        "line-height": "1.75rem",
        "padding": "0px 0px 0px 0px"
      },
      "fonts": {
        "styleProps": ""
      }
    },
    {
      "type": "text",
      "id": 1746533060416,
      "elIndex": 1,
      "text": "[[role]]",
      "location": "B",
      "params": [
        {
          "value": "role",
          "label": "role"
        }
      ],
      "styleProps": {
        "padding": "0px 0px 16px 0px",
        "text-align": "left",
        "color": "#808080",
        "font-size": "1.25rem",
        "line-height": "1.75rem",
        "font-weight": "400"
      },
      "stylePropsTab": {
        "font-size": "1.25rem",
        "line-height": "1.75rem",
        "padding": "0px 0px 10px 0px"
      },
      "stylePropsMob": {
        "font-size": "1rem",
        "line-height": "1.5rem",
        "padding": "0px 0px 4px 0px"
      }
    },
    {
      "type": "text",
      "id": 1746622309663,
      "elIndex": 2,
      "text": "[[description]]",
      "params": [
        {
          "value": "description",
          "label": "description"
        }
      ],
      "location": "B",
      "styleProps": {
        "text-align": "left",
        "margin": "0px 0px 10px 0px",
        "border-width": "0px",
        "border-color": "#116dff",
        "color": "#808080"
      },
      "stylePropsTab": {
        "margin": "0px 0px 0px 0px"
      },
      "stylePropsMob": {
        "margin": "0px 0px 0px 0px",
        "font-size": "0.875rem",
        "line-height": "1.25rem"
      }
    },
    {
      "type": "text",
      "id": 1747061193436,
      "elIndex": 3,
      "text": "Status : [[status ]]",
      "location": "B",
      "params": [
        {
          "value": "status",
          "label": "status "
        }
      ],
      "styleProps": {
        "font-weight": "600",
        "font-size": "1.125rem",
        "line-height": "1.75rem",
        "margin": "10px 0px 0px 0px"
      },
      "stylePropsMob": {
        "font-size": "1rem",
        "line-height": "1.5rem"
      },
      "stylePropsTab": {
        "font-size": "1rem",
        "line-height": "1.5rem"
      }
    },
    {
      "type": "text",
      "id": 1747061254483,
      "elIndex": 4,
      "text": "Email : [[email]]",
      "location": "B",
      "params": [
        {
          "value": "email",
          "label": "email"
        }
      ],
      "styleProps": {
        "font-weight": "600",
        "font-size": "1.125rem",
        "line-height": "1.75rem",
        "margin": "10px 0px 0px 0px",
        "text-align": "left"
      },
      "stylePropsMob": {
        "font-size": "1rem",
        "line-height": "1.5rem"
      },
      "stylePropsTab": {
        "font-size": "1rem",
        "line-height": "1.5rem"
      }
    },
    {
      "type": "text",
      "id": 1747061321964,
      "elIndex": 5,
      "text": "Date: [[date]]",
      "location": "B",
      "params": [
        {
          "value": "date",
          "label": "date"
        }
      ],
      "styleProps": {
        "font-size": "1.125rem",
        "line-height": "1.75rem",
        "font-weight": "600",
        "margin": "10px 0px 0px 0px",
        "text-align": "left"
      },
      "stylePropsMob": {
        "font-size": "1rem",
        "line-height": "1.5rem"
      },
      "stylePropsTab": {
        "font-size": "1rem",
        "line-height": "1.5rem"
      }
    }
  ],
  "cardConfig": {
    "perRow": {
      "mobile": 1,
      "tab": 2,
      "desktop": 3
    },
    "layout": "l5",
    "cardstyleProps": {
      "padding": "8px 8px 8px 8px"
    },
    "cardstylePropsTab": {
      "padding": "8px 8px 8px 8px"
    },
    "cardstylePropsMob": {
      "padding": "0px 0px 8px 0px"
    }
  },
  "configs": {
    "dataType": "dynamic",
    "connection": {
      "spreadsheetId": "",
      "sheetName": "",
      "connectionId": "",
      "connectionTable": "",
      "timestamp": 1747061971193
    },
    "params": [],
    "filters": {
      "categories": []
    },
    "searchConfig": {
      "showSearchBar": false,
      "searchButton": {
        "styleProps": {
          "color": "#ffffff",
          "padding": "5px 20px 5px 20px",
          "background-color": "#333333",
          "border-radius": "1.5rem",
          "margin": "0px 10px 0px 10px",
          "font-weight": "bold",
          "width": "auto"
        },
        "stylePropsMob": {
          "width": "auto"
        }
      },
      "clearButton": {
        "styleProps": {
          "background-color": "#ececec",
          "color": "#333333",
          "padding": "5px 20px 5px 20px",
          "border-radius": "9999px"
        }
      },
      "searchContainer": {
        "styleProps": {
          "background-color": "#ececec",
          "border-radius": "1.5rem",
          "padding": "10px 20px 10px 10px",
          "margin": "30px 0px 30px 0px",
          "width": "auto"
        },
        "stylePropsTab": {
          "border-radius": "9999px"
        },
        "stylePropsMob": {
          "border-radius": "1rem",
          "width": "100%"
        }
      },
      "input": {
        "styleProps": {
          "border-radius": "9999px",
          "padding": "5px 20px 5px 20px",
          "color": "#333333",
          "font-weight": "100",
          "background-color": "#ffffff",
          "width": "auto"
        },
        "stylePropsMob": {
          "margin": "0px 0px 10px 0px",
          "width": "100%"
        }
      }
    },
    "sortBy": {
      "columnName": "",
      "ascending": true
    },
    "id": "1723883803066"
  },
  "metaDataId": 1747060290529,
  "afterIndex": 6,
  "blockId": 1747060290529,
  "stylePropsTab": {
    "padding": "80px 20px 80px 20px"
  },
  "stylePropsMob": {
    "padding": "60px 10px 60px 10px"
  },
  "cardLocations": [
    {
      "name": "outer",
      "styleProps": {
        "background-image": "url('')",
        "border-radius": "1.5rem",
        "padding": "0px 0px 0px 0px",
        "background-repeat": "no-repeat",
        "background-size": "cover",
        "background-color": "#ffffff",
        "box-shadow": ""
      }
    },
    {
      "name": 0
    },
    {
      "name": "A",
      "styleProps": {
        "background-color": "",
        "margin": "0px 0px 0px 0px",
        "border-radius": "1.5rem 1.5rem 0rem 0rem",
        "padding": "0px 0px 0px 0px",
        "box-shadow": "",
        "alignItems": "flex-start",
        "justify-content": "flex-start",
        "flex-direction": "",
        "display": "",
        "width": "100%",
        "text-align": "left",
        "background-image": "url('[[img]]')",
        "background-repeat": "no-repeat",
        "background-position": "center",
        "background-size": "cover"
      },
      "stylePropsTab": {
        "padding": "0px 0px 0px 0px"
      },
      "stylePropsMob": {
        "padding": "0px 0px 0px 0px"
      },
      "innerDiv": {
        "styleProps": {
          "height": "256px",
          "display": "",
          "justify-content": "",
          "background-image": "linear-gradient(to bottom,,)",
          "padding": "20px 20px 20px 20px",
          "border-radius": "0px"
        },
        "stylePropsTab": {
          "height": "256px"
        },
        "stylePropsMob": {
          "height": "256px"
        }
      }
    },
    {
      "name": "B",
      "styleProps": {
        "padding": "50px 40px 40px 40px",
        "display": "flex",
        "flex-direction": "column",
        "justify-content": "center",
        "width": "100%",
        "alignItems": "",
        "text-align": "center",
        "background-image": "url('')",
        "background-color": "[[bgcolor]]",
        "border-radius": "0rem 0rem 1.5rem 1.5rem"
      },
      "innerDiv": {
        "styleProps": {
          "justify-content": "left",
          "alignItems": "flex-start"
        }
      },
      "stylePropsMob": {
        "padding": "30px 20px 30px 20px"
      },
      "stylePropsTab": {
        "padding": "30px 20px 30px 20px"
      }
    },
    {
      "name": "C",
      "styleProps": {
        "width": "100%",
        "display": "flex",
        "flex-direction": "row",
        "alignItems": "center",
        "justify-content": "center",
        "text-align": "center",
        "border-color": "#33333333",
        "border-width": "0px",
        "padding": "0px 0px 0px 0px"
      },
      "innerDiv": {
        "styleProps": {
          "width": "100%",
          "display": "flex",
          "flex-direction": "row",
          "alignItems": "center",
          "justify-content": "center"
        }
      },
      "stylePropsTab": {
        "padding": "0px 0px 0px 0px"
      }
    }
  ],
  "overlay": {
    "styleProps": {
      "background-color": ""
    }
  },
  "containerStyleProps": {
    "max-width": "1280px"
  }
}